import React from "react";

const Radios = ({ label, reqd, data, value, click, inline = false }) => {
	const labels = data.map((item, index) => {
		return (
			<label
				key={index}
				className={!item.label ? "hidden" : ""}
				style={{
					display: "flex",
					alignItems: "center",
					cursor: item.disabled ? "not-allowed" : "pointer",
				}}
			>
				<input
					type="radio"
					name={item.name}
					value={item.val}
					defaultChecked={item.val === value}
					onClick={(e) => click(item.name, e.target.value)}
					disabled={item.disabled ? true : false}
				/>
				<span className={item.disabled ? "disabled" : ""}>{item.label}</span>
			</label>
		);
	});

	return (
		<div>
			<label>
				{label} <span className="reqd">{reqd ? "*" : " "}</span>
			</label>
			<div className={inline ? "inline" : ""}>{labels}</div>
		</div>
	);
};

export default Radios;
